import dayjs from 'dayjs'
import { convertKeysToCamelCase } from 'utils/utilCommon'
import { supabase } from '../axios.instance'

export const getCountRentalCountRPC = async regionId => {
    try {
        const response = await supabase
            .rpc('get_tools_rental_status_counts_by_region', {
                p_region_id: regionId,
            })
            .single()
        let camelCasePayload
        if (regionId) {
            camelCasePayload = convertKeysToCamelCase(response.data)
        }
        return camelCasePayload
    } catch (err) {
        console.log(err)
        return null
    }
}

/**
 * 지역통계 쿼리 RPC
 * @param regionId
 * @returns {Promise<null>}
 */
export const getCountRPC = async (regionId, monthOfReport, year) => {
    try {
        let region = regionId
        let month
        let years
        if (monthOfReport) {
            month = dayjs(monthOfReport).format('M')
        }
        if (year) {
            years = dayjs(year).format('YYYY')
        }
        if (region === 'all') {
            region = ''
        }
        const params = { region_id_param: region }
        if (month !== undefined) {
            params.month_of_report_param = Number(month)
        }
        if (years !== undefined) {
            params.year_param = Number(years)
        }

        const response = await supabase.rpc('get_count_v2', params)
        let camelCasePayload
        if (regionId && regionId !== 'all') {
            camelCasePayload = convertKeysToCamelCase(response.data[0])
        } else {
            camelCasePayload = convertKeysToCamelCase(response.data)
        }
        return camelCasePayload
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 연도별 지역 카운트 RPC
 * @param {string} region_id_param
 * @param {number} year_param
 * @returns {Promise<null|object>}
 */
export const getCountRegionYearRPC = async (region_id_param, year_param) => {
    try {
        const response = await supabase.rpc('get_count_region_year', {
            region_id_param,
            year_param,
        })
        let camelCasePayload
        if (region_id_param && region_id_param !== 'all') {
            camelCasePayload = convertKeysToCamelCase(response.data[0])
        } else {
            camelCasePayload = convertKeysToCamelCase(response.data)
        }
        return camelCasePayload
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 교육관리 필터영역 카운트 RPC
 * @param regionId
 * @returns {Promise<null>}
 */
export const getCountProgramCountRPC = async params => {
    try {
        const regionId = params.region_id ? params.region_id.replace('eq.', '') : 'all'
        const classHours = params.class_hours ? params.class_hours : null
        const status = params.status ? params.status.replace('eq.', '') : null
        const education = params.education_type ? params.education_type.replace('eq.', '') : null
        const course = params.course ? params.course.replace('eq.', '') : null
        const category = params.category ? params.category.replace('eq.', '') : null
        const grade = params.grade ? params.grade.replace('eq.', '') : null
        const startDate = params.start_date ? params.start_date.replace('gte.', '') : null
        const endDate = params.end_date ? params.end_date.replace('lte.', '') : null

        const response = await supabase.rpc('get_program_count_new', {
            region_id_param: regionId,
            class_hours_param: classHours,
            status_param: status,
            education_type_param: education,
            course_param: course,
            category_param: category,
            grade_param: grade,
            start_date_param: startDate,
            end_date_param: endDate,
            method_param: null,
            registration_year_param: null,
        })
        return response.data[0]
    } catch (error) {
        console.error(error)
        return null
    }
}
/**
 * 강사 필터영역 카운트 RPC
 * @param regionId
 * @returns {Promise<null>}
 */
export const getTutorCountRPC = async params => {
    try {
        const regionId = params.region_id ? params.region_id.replace('eq.', '') : 'all'
        const isYouth = params.is_youth ? params.is_youth.replace('eq.', '') : null
        const isRetiree = params.is_retiree ? params.is_retiree.replace('eq.', '') : null
        const isCareerGap = params.is_career_gap_female ? params.is_career_gap_female.replace('eq.', '') : null

        const isAdvanced = params.is_advanced_instructor ? params.is_advanced_instructor.replace('eq.', '') : null
        const isEmployment = params.is_employment ? params.is_employment.replace('eq.', '') : null
        const isForeign = params.is_foreign ? params.is_foreign.replace('eq.', '') : null
        const hasDisability = params.has_disability ? params.has_disability.replace('eq.', '') : null
        const isVeterans = params.is_veterans ? params.is_veterans.replace('eq.', '') : null
        const educationLevel = params.education_level ? params.education_level.replace('eq.', '') : null
        const teacherCertification = params.teacher_certification
            ? params.teacher_certification.replace('eq.', '')
            : null
        const teachingExperience = params.teaching_experience_yn
            ? params.teaching_experience_yn.replace('eq.', '')
            : null
        const employmentStatus = params.employment_status ? params.employment_status.replace('eq.', '') : null
        // TODO: RPC 함수에서 "위촉" 필터링 시 "협동조합"도 포함되도록 서버 측 RPC 함수 수정 필요
        // 현재는 클라이언트 측 buildSupabaseChainFilter에서만 처리됨
        const employmentType = params.employment_type ? params.employment_type.replace('eq.', '') : null
        const startDate = params.start_date ? params.start_date.replace('gte.', '') : null
        const endDate = params.end_date ? params.end_date.replace('lte.', '') : null
        const response = await supabase.rpc('get_tutor_counts', {
            region_id_param: regionId,
            is_youth_param: isYouth,
            is_retiree_param: isRetiree,
            is_career_gap_female_param: isCareerGap,
            is_advanced_instructor_param: isAdvanced,
            is_employment_param: isEmployment,
            is_foreign_param: isForeign,
            has_disability_param: hasDisability,
            is_veterans_param: isVeterans,
            education_level_param: educationLevel,
            teacher_certification_param: teacherCertification,
            teaching_experience_yn_param: teachingExperience,
            employment_status_param: employmentStatus,
            employment_type_param: employmentType,
            start_date_param: startDate,
            end_date_param: endDate,
        })
        return response.data[0]
    } catch (error) {
        console.error(error)
        return null
    }
}
/**
 * 자산관리 필터영역 카운트 RPC
 * @param regionId
 * @returns {Promise<null>}
 */
export const getToolsInventoryCountRPC = async params => {
    try {
        const regionId = params.region_id ? params.region_id.replace('eq.', '') : 'all'
        const state = params.tools_state ? params.tools_state.replace('eq.', '') : null
        const acquireDate = params.acquire_date ? params.acquire_date.replace('eq.', '') : null

        const response = await supabase.rpc('get_tools_inventory_counts', {
            region_id_param: regionId,
            state_param: state,
            acquire_date_param: acquireDate,
        })
        return response.data[0]
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 페이지 정보 RPC
 * @param table
 * @param regionId
 * @param pageSize
 * @returns {Promise<null>}
 */
export const getPageInfoRPC = async (table, regionId, pageSize) => {
    try {
        const response = await supabase.rpc('get_pages_info', {
            table_name: table,
            region_id_param: regionId,
            page_size: pageSize,
        })
        return response.data[0]
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 테이블 별 페이지 정보 get 함수
 * @param search
 * @param table
 * @param regionId
 * @param pageSize
 * @returns {Promise<{totalItems: *, totalPages: *, pageSize: *, currentPage: string|number}>}
 */
export const getCommonPageInfo = async (search, table, regionId, pageSize) => {
    const currentPage = Number(new URLSearchParams(search).get('page')) || 1
    let pageInfo = await getPageInfoRPC(table, regionId, pageSize)
    pageInfo = convertKeysToCamelCase(pageInfo)
    const { totalPages, totalItems } = pageInfo

    return {
        currentPage,
        totalPages,
        totalItems,
        pageSize,
    }
}

/**
 * 대여 및 교구 정보 수정
 * @param {object} params - Supabase RPC 파라미터
 * @returns {Promise} - Supabase RPC 호출 결과
 */
export const updateRentalAndItems = async params => {
    try {
        const response = await supabase.rpc('update_rental_and_items_v2', params).select()
        return response
    } catch (error) {
        console.error('updateRentalAndItems 오류:', error)
        throw error
    }
}

export const insertToolsRental = async data => {
    const response = await supabase.rpc('rpc_insert_tools_rental', { _data: data })
    return response
}

export const findToolsInventoryIndexed = async (regionId, toolsNames, toolsNums) => {
    const response = await supabase.rpc('find_tools_inventory_indexed', {
        region_id_param: regionId,
        tools_name_param: toolsNames,
        tools_num_param: toolsNums,
    })
    return response
}

export const findTutorIdsIndexed = async (regionId, tutorNames) => {
    const response = await supabase.rpc('find_tutor_ids_indexed', {
        region_id_param: regionId,
        tutor_name_param: tutorNames,
    })
    return response
}

/**
 * 프로그램 정보 조인 강사 정보 RPC
 * @param params
 * @returns {Promise<null>}
 */
export const getProgramInfoJoinTutorRPC = async (offset, limit, id = '') => {
    try {
        const params = {
            offset_val: offset,
            limit_val: limit,
            ...(id && { region_id_param: id }), // id가 존재할 경우에만 추가
        }

        const response = await supabase.rpc('program_info_join_tutor_v2', params)

        return response
    } catch (error) {
        console.error(error)
        return null
    }
}

/**
 * 자산관리 정보 RPC
 * @param params
 * @returns {Promise<null>}
 */
export const getToolsInventoryRpc = async (offset, limit, id = '') => {
    try {
        const params = {
            offset_val: offset,
            limit_val: limit,
            ...(id && { id_param: id }),
        }

        const response = await supabase.rpc('get_tools_inventory', params)

        return response
    } catch (err) {
        console.log(err)
        return null
    }
}

/**
 * 대여반납 정보 RPC
 * @param params
 * @returns {Promise<null>}
 */
export const getToolsRentalRpc = async (offset, limit, id = '') => {
    try {
        const params = {
            offset_val: offset,
            limit_val: limit,
            ...(id && { id_param: id }),
        }

        const response = await supabase.rpc('get_tools_rental', params)

        return response
    } catch (err) {
        console.log(err)
        return null
    }
}

/**
 * 월별 대시보드 알림 조회
 * @param month 1~12월 (숫자)
 */

export const getAlarmRpc = async month => {
    try {
        const { data, error } = await supabase.rpc('get_region_total_noti', {
            month_param: month,
        })
        if (error) {
            console.log('AlarmError', error.message)
            return []
        }
        return data ?? []
    } catch (err) {
        console.log(err)
        return []
    }
}

/**
 * 지역 관리자 월별 대시보드 알림 조회
 * @param month 1~12월 (숫자)
 */
export const getUserDashBoardRpc = async (month, region) => {
    try {
        const { data, error } = await supabase.rpc('get_region_month_board', {
            month_param: month,
            region_param: region,
        })
        if (error) {
            console.log('AlarmError', error.message)
            return []
        }
        return data ?? []
    } catch (err) {
        console.log(err)
        return []
    }
}
/**
 *  대시보드 에러 데이터 조회
 */
export const getErrorRpc = async (region = '') => {
    try {
        const { data, error } = await supabase.rpc('get_error_data', {
            region_param: region,
        })
        if (error) {
            console.log('AlarmError', error.message)
            return []
        }
        return data ?? []
    } catch (err) {
        console.log(err)
        return []
    }
}

/**
 *  대시보드 공지사항 조회
 */
export const getNoticeRpc = async () => {
    try {
        const { data, error } = await supabase.rpc('get_notice', {})
        if (error) {
            console.log('AlarmError', error.message)
            return []
        }
        return data ?? []
    } catch (err) {
        console.log(err)
        return []
    }
}

// 도서벽지 조회
export const getCategoryRpc = async (name, address = '') => {
    // ✅ 공백/제로폭 공백 제거 + 한글 정규화(NFC)
    const normalizeOrg = v =>
        String(v ?? '')
            .normalize('NFC')
            .replace(/[\s\u200B-\u200D\uFEFF]/g, '')

    // 문자열 또는 { name } 대응
    const normName = typeof name === 'string' ? normalizeOrg(name) : normalizeOrg(name?.name)

    try {
        const { data, error } = await supabase.rpc('is_right_island', {
            name_param: normName,
            address_param: address,
        })
        if (error) {
            console.error('CategoryError', error.message, { normName })
            return []
        }
        return data ?? []
    } catch (err) {
        console.error('CategoryError', err)
        return []
    }
}
